import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
    selector: '[moneyInput]',
    standalone: false
})
export class MoneyInputDirective {
    private static readonly allowedSystemKeys = [
        'Backspace', 'Delete', 'Tab', 'Enter', 'Escape',
        'ArrowLeft', 'ArrowRight', 'Home', 'End'
    ];

    constructor(private el: ElementRef<HTMLInputElement>) { }

    @HostListener('keydown', ['$event'])
    onKeyDown(e: KeyboardEvent): void {
        if ((e.ctrlKey || e.metaKey) && ['a', 'c', 'v', 'x'].includes(e.key.toLowerCase())) {
            return;
        }

        if (MoneyInputDirective.allowedSystemKeys.includes(e.key)) {
            return;
        }

        const isDigit = /^\d$/.test(e.key);
        const isDot = e.key === '.';

        if (
            !isDigit &&
            !(isDot && !this.el.nativeElement.value.includes('.'))
        ) {
            e.preventDefault();
        }

        const indexOfDot = this.el.nativeElement.value.indexOf('.');

        if (indexOfDot !== -1 && this.el.nativeElement.value.substring(indexOfDot).length > 2) {
            e.preventDefault();
        }
    }

    @HostListener('paste', ['$event'])
    onPaste(e: ClipboardEvent): void {
        const text = (e.clipboardData ?? new DataTransfer()).getData('text');
        if (!/^\d*\.?\d*$/.test(text)) {
            e.preventDefault();
        }
    }
}